module.exports = __webpack_public_path__ + "static/media/room-4.c5dd6c7a.jpeg";